import { observer } from "mobx-react";
import useDashboardTranslation from "./hooks/dashboard-translation-hook";

interface IProps {
    translationKey: string;
    scope: string;
    params?: any[];
}

const DashTranslation = observer(({ translationKey, scope, params }: IProps) => {
    const { getTranslation } = useDashboardTranslation();

    return (
        <span dangerouslySetInnerHTML={{ __html: (getTranslation(translationKey, scope, params) ?? '')}} />
    )
});

export default DashTranslation;
